import { siteTitle } from "@1-now/booking-core";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * 1NOW-11189: the tab title every route starts from, for the site headers of Designs A and B.
 *
 * It is the operator's SEO title, then their name (siteTitle with no page label), written on
 * the first render with the payload and again on every route change, so a page with no title of
 * its own (home, Privacy Policy, Terms, Pay Later) never keeps the previous page's. A page that
 * does set one (Vehicles, About, Contact, Track my booking) calls useDocumentTitle itself and
 * wins, because effects run in tree order and the header comes before the routes (or, on Design
 * B's home, About and Contact, is a child of the page, and child effects run first).
 *
 * Nothing is written until the payload has landed: a placeholder would flash over the title
 * index.html already carries.
 */
export const useSiteTitle = (companyDetails?: { company_name?: string | null; seo_title?: string | null } | null) => {
  const { pathname } = useLocation();
  const title = companyDetails ? siteTitle(companyDetails) : undefined;
  useEffect(() => {
    if (title && document.title !== title) document.title = title;
  }, [title, pathname]);
};
